import React, {useState, useEffect, useContext} from 'react';
import { Form, Input, Button, Checkbox, Select, message, Modal, Row, Col } from 'antd';
import './styles.css';
import { validateEmail, validatePhoneNumber } from '../../helpers/validator';
import axios from 'axios';
//const signalR = require('@microsoft/signalr');
const { Option } = Select;
const LoginContent = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const [form] = Form.useForm();     
  const onFinish = async (values: any) => {
    try {
        const rawResponse = await fetch(process.env.REACT_APP_API_URL_FOR_CHAT + 'api/Authenticate', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "email": values.username,
                "password": values.password,
                "role": '3'
            })
        });
        const data = await rawResponse.json();
        console.log("API Response:", data); // Debugging
        // Check if response contains an error message
        if (data.message && data.message === "Invalid credentials") {
            message.info('Nhập sai thông tin hoặc chưa đăng ký tài khoản', 10);
            return;
        }
        // Save login details in localStorage
        localStorage.setItem("emailData", values.username);
        localStorage.setItem("token", data.token);
        localStorage.setItem("tokenRefresh", data.tokenRefresh);
        localStorage.setItem("userNameData", data.userCode);
        localStorage.setItem("userFullName", data.userFullName);
        localStorage.setItem("passwordStatus", data.passwordStatus);
        localStorage.setItem("avatar", data.avatar ?? '');
        localStorage.setItem("taxCode", data.taxCode);
        
        window.location.reload();
    } catch (error) {
        console.error("Login error:", error);
        message.error('Lỗi khi đăng nhập, vui lòng thử lại sau', 10);
    }
}; 
  const onFinishRegister = async (values: any) => {
    const formData = new FormData();
          formData.append("Email", values.MyEmail);
          formData.append("FullName", values.FullName);
          formData.append("PhoneNumber", values.PhoneNumber);
          formData.append("Password", "abc123!");
          formData.append('TaxCode', 'volodia1917@gmail.com');        
          const config = {     
            headers: { "Content-Type": "multipart/form-data" }
          }
          axios.post(process.env.REACT_APP_API_URL_FOR_CHAT+'api/User', formData, config)
            .then(response => {
                  message.info(response.data.message, 10);
                  setIsModalOpen(false);
            })
            .catch(error => {
                message.info("Đã có lỗi trong quá trình đăng ký", 10);
            });       
        };
  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };
  return (
    <div className="login-container">
      <div className="login-form">
        <h2>Đăng nhập</h2>
        <Form
          name="basic"
          initialValues={{ role: '1' }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout="vertical"
        >
          <Form.Item
            label='Email'
            name="username"
            rules={[{ required: true, message: 'Vui lòng nhập email!' }]}
          >
            <Input style={{border:'none'}} placeholder='Tên đăng nhập' />
          </Form.Item>
          <Form.Item
            label='Mật khẩu'
            name="password"
            rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!'}]}
          >
            <Input.Password style={{border:'none'}} placeholder='Nhập mật khẩu' />
          </Form.Item>
          <a href="/resetpass">Quên mật khẩu - Reset mật khẩu</a>&nbsp;&nbsp;&nbsp;
          <Form.Item name="remember" valuePropName="checked" noStyle>
            <Checkbox>Ghi nhớ mật khẩu</Checkbox>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: '100%', marginTop:'20px' }}>
              Đăng nhập
            </Button>
            <Button type="primary" style={{ width: '100%', marginTop:'20px' }} onClick={showModal}>
              Đăng ký
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className="illustration">
        <img src="images/loginWelcome.png" alt="Illustration" style={{ width: '100%' }} />
      </div>
      <Modal title="" open={isModalOpen} footer={null} onOk={handleOk} onCancel={handleCancel}>
      <Form
      form={form}
      layout="vertical"
      onFinish={onFinishRegister}
      style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px', backgroundColor: '#f0f2f5', borderRadius: '8px' }}
    >
      <h2 className='RegisterHeader' style={{ textAlign: 'left', color: '#ff4d4f' }}>ĐIỀN THÔNG TIN ĐĂNG KÝ</h2>
      <Row gutter={24}>
      <Col xs={24} sm={24} md={18}>
          <Form.Item
            name="FullName"
            label="Họ và tên"
            rules={[{ required: true, message:'Thông tin này không được bỏ trống!'}]}
          >
            <Input placeholder="Họ và tên" />
          </Form.Item>
        </Col>        
      </Row>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={18}>
          <Form.Item
            name="MyEmail"
            label="Địa chỉ email"
            rules={[{ required: true, message: 'Thông tin này không được bỏ trống!'},{validator:validateEmail}]}
          >
            <Input placeholder="Địa chỉ email" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={18}>
          <Form.Item
            name="PhoneNumber"
            label='Điện thoại'
            rules={[{ required: true, message: 'Thông tin này không được bỏ trống!'}, {validator:validatePhoneNumber}]}
          >
            <Input placeholder="Nhập số điện thoại" />
          </Form.Item>
        </Col>       
      </Row>
      <Form.Item>
        <Button type="primary" htmlType="submit" style={{ backgroundColor: '#ff4d4f', borderColor: '#ff4d4f' }}>
          Gửi
        </Button>
      </Form.Item>
    </Form>
      </Modal>
    </div>
  );
};
export default LoginContent;
